'use client';

import { useEffect, useState } from 'react';

const ENV_DEFAULT = process.env.NEXT_PUBLIC_CHARTER_FEATURE_CONCIERGE === '1';

export function useConciergeEnabled(): { enabled: boolean; loading: boolean } {
  const [enabled, setEnabled] = useState<boolean>(ENV_DEFAULT);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const API_URL = process.env.NEXT_PUBLIC_API_URL || '/api';
    fetch(`${API_URL}/settings/public/concierge`)
      .then(r => r.json())
      .then(data => {
        if (data?.success && typeof data.data?.enabled === 'boolean') {
          setEnabled(data.data.enabled);
        }
      })
      .catch(() => {
        setEnabled(ENV_DEFAULT);
      })
      .finally(() => setLoading(false));
  }, []);

  return { enabled, loading };
}
